import { useEffect, useRef } from 'react';

type Props = {
    visible: boolean;
    onPlayerClosed(): void;
};

function useOnPlayerClose({ visible, onPlayerClosed }: Props) {
    const prevVisible = useRef(visible);

    useEffect(() => {
        if (prevVisible.current && !visible) {
            onPlayerClosed();
        }

        prevVisible.current = visible;
    }, [visible]);
}

export default useOnPlayerClose;
